import { useEffect, useState } from "react";

// Shows a small "new version available" banner when a fresh service worker is waiting,
// so an installed PWA never stays stuck on an old build. Tapping Refresh activates the
// new worker and reloads.
export default function UpdatePrompt() {
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    let clicked = false;

    const onControllerChange = () => {
      if (clicked) window.location.reload();
    };
    navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);

    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((reg) => {
      const track = (worker) => {
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) setWaiting(worker);
        });
      };
      if (reg.waiting && navigator.serviceWorker.controller) setWaiting(reg.waiting);
      reg.addEventListener("updatefound", () => track(reg.installing));
      // Poll for a new deploy every 60s while the app is open.
      const id = setInterval(() => reg.update().catch(() => {}), 60000);
      window.__rqSwPoll = id;
    }).catch(() => {});

    window.__rqSetClicked = () => { clicked = true; };
    return () => {
      navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
      if (window.__rqSwPoll) clearInterval(window.__rqSwPoll);
    };
  }, []);

  if (!waiting) return null;

  const refresh = () => {
    if (window.__rqSetClicked) window.__rqSetClicked();
    waiting.postMessage({ type: "SKIP_WAITING" });
  };

  return (
    <div data-testid="update-prompt"
      style={{ position: "fixed", left: "50%", bottom: 20, transform: "translateX(-50%)", zIndex: 9999,
        display: "flex", alignItems: "center", gap: 14, maxWidth: "calc(100vw - 32px)",
        background: "#0B1E3B", color: "#fff", padding: "12px 16px", borderRadius: 12,
        boxShadow: "0 12px 40px rgba(0,0,0,0.35)", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <span style={{ fontSize: 13.5, fontWeight: 500 }}>A new version of ResQ1 is available.</span>
      <button onClick={refresh} data-testid="update-refresh-btn"
        style={{ background: "#E01A2E", color: "#fff", border: 0, borderRadius: 999, padding: "8px 18px",
          fontSize: 13, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
        Refresh
      </button>
    </div>
  );
}
